module.exports = __webpack_public_path__ + "img/高效低本的AISM智能供应协同.cfeb45c9.png";